import React from 'react';
import { ContentBox } from '../ContentBox/ContentBox';
import { TaskState } from 'gql/graphql';

interface IProps {
  loanSelected: any;
  setTaskOpenModal: any;
  tasks: any;
}

const ViewInfo = ({ url }: { url: string | null }) => {
  if (!url) return null
  return (<span onClick={() => { window.open(url, '_blank'); }}>{"View info ->"}</span>)
};

export const BoxPartners: React.FC<IProps> = ({ loanSelected, setTaskOpenModal: openTask, tasks }: IProps) => {

  const getContactField = (
    label: string,
    data: any,
    taskKey: string,
    draftMessage?: string,
    showNoContact: boolean = false
  ) => {
    const task = tasks.find((item: any) => item.key === taskKey);
    if (taskKey === 'entity_guarantors') taskKey = 'entity_guarantor';
    
    if (task?.key === 'title_company' && task?.state === TaskState.Review &&
      !task?.metadata?.titleCompany) {
      return { field: label, value: <>{"In review"}</> };
    }

    if (task?.key === 'title_company' && task?.state === TaskState.Approved &&
      !task?.metadata?.titleCompany) {
      return { field: label, value: <>{"Approved"}</> };
    }

    if (taskKey === 'entity_docs' && task?.state === TaskState.ComingSoon) {
      return { field: label, value: <span onClick={() => openTask('entity_guarantor')}>{draftMessage}</span> };
    }

    if ((task?.state === TaskState.Draft || task?.state === TaskState.Incomplete) && draftMessage) {
      return { field: label, value: <span onClick={() => openTask(taskKey)}>{draftMessage}</span> };
    }

    if (task?.state === TaskState.RequestError) {
      return { field: label, value: <span onClick={() => openTask(taskKey)}>{"In error ->"}</span> };
    }

    if (task?.state === TaskState.Review) {
      return { field: label, value: <span onClick={() => openTask(taskKey)}>{`In ${task.state.toLowerCase()} ->`}</span> };
    }

    if (task?.state === TaskState.Approved) {
      return { field: label, value: <span onClick={() => openTask(taskKey)}>{"Approved ->"}</span> };
    }

    if (showNoContact || task?.state === TaskState.Draft) {
      return { field: label, value: <span onClick={() => openTask(taskKey)}>{"No contact set ->"}</span> };
    }

    return { field: label, value: <span onClick={() => openTask(taskKey)}>{"No contact set ->"}</span> };
  };


  const propertyTask = tasks.find((item: any) => item.key === 'property_access');

  return (
    <ContentBox
      label={'Partners and contacts'}
      content={[
        getContactField('Entity', loanSelected?.salesforceData?.entity, 'entity_docs', "Complete entity info ->"),
        getContactField('Guarantors', loanSelected?.salesforceData?.guarantors?.[0], 'entity_guarantors', "Complete guarantor profiles ->"),
        {
          field: 'Main loan contact',
          value: loanSelected?.salesforceData?.mainLoanContact?.url
            ? <>{loanSelected.salesforceData.mainLoanContact.name}</>
            : propertyTask?.metadata?.name
              ? <>{propertyTask.metadata.name}</>
              : <>{loanSelected?.owner?.name || "No contact set ->"}</>,
        },
        getContactField('Title agent', loanSelected?.salesforceData?.titleAgent, 'title_company'),
        getContactField('Insurance agent', loanSelected?.salesforceData?.insuranceAgent, 'insurance', undefined, true),
        ...(loanSelected.purpose === "Refinance"
          ? [getContactField('Payoff contact', loanSelected?.salesforceData?.payoffContact, 'payoff', undefined, true)]
          : []
        )
      ]}
    />
  );
}